import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';

import { fee } from '../../core/controllers/Fee';
import { modal } from '../../core/utilities/modal'

export default class FeeEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            feeId : props.feeId,
            newFee: props.newFee ? true : false,
            sortID: null,
            fee: {
                fee_title: '',
                fee_description: '',
                fee_type: 0,
                fee_amount: 0,
                fee_percentage: 0,
                is_global: 0,
                is_late_rent: false,
            }
        };
    }

    componentDidMount() {
        var self = this;
        if(this.state.newFee == false) {
            fee.getFee(this.state.feeId,function(response) {
                var feeData = response.data.fee;
                feeData.fee_amount = self.formatAmount(feeData.fee_amount / 100);
                feeData.is_late_rent = feeData.fee_type == 1 ? true : false;
                self.setState({
                    fee: feeData
                });
            });
        }
    }

    componentDidUpdate() {
    }

    handleNameChange(e){
        this.setState({
            fee: update(this.state.fee, {
                fee_title: {$set: e.target.value}
            })
        });
    }

    handleDescriptionChange(e){
        this.setState({
            fee: update(this.state.fee, {
                fee_description: {$set: e.target.value}
            })
        });
    }

    handleFeeTypeChange(e){
        this.setState({
            fee: update(this.state.fee, {
                fee_type: {$set: e.target.value}
            })
        });
    }

    handleFeeAmountChange(e) {
        this.setState({
            fee: update(this.state.fee, {
                fee_amount: {$set: e.target.value}
            })
        });
    }

    handleFeePercentageChange(e) {
        const value = this.validatePercentage(e.target.value);
        this.setState({
            fee: update(this.state.fee, {
                fee_percentage: {$set: value}
            })
        });
    }

    handleIsGlobalChange(e) {
        this.setState({
            fee: update(this.state.fee, {
                is_global: {$set: e.target.value}
            })
        });
    }

    handleIsLateRent(e) {
        this.setState({
            fee: update(this.state.fee, {
                is_late_rent: {$set: e.target.checked}
            })
        });
    }

    formatAmount(value) {
        value = value.toString();
        value = value.replace(',', '');
        if(isNaN(value) || value === 0) {
            value = 0;
        } else {
            value = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(value)
        }

        return value;
    }

    validatePercentage(value) {
        value = value.replace(/\D/g,'');

        if (parseInt(value) >= 0 && parseInt(value) <= 100) {
            return value;
        } else {
            return '';
        }
    }

    updateFee(e) {
        if(!this.validateData()){
            return;
        }
        var self = this;
        fee.updateFee(this.state.fee, function(response) {
            modal.resetBackDrop();
            modal.showInfo("Fee has been updated.", "success", "top", "center");
            self.props.goBack();
        });
    }

    deleteFee(e) {
        var self = this;
        fee.deleteFee(this.state.feeId, function(response) {
            modal.resetBackDrop();
            modal.showSuccess('Fee deleted!', 'Fee has been removed.');
            jQuery(".move-on").on('click',function() {
                self.props.goBack();
            });
        });
    }

    saveFee(e) {
        if(!this.validateData()){
            return;
        }
        var self = this;
        fee.saveFee(this.state.fee, function(response) {
            modal.resetBackDrop();
            modal.showSuccess('Fee Added!', 'Fee has been added.');
            jQuery(".move-on").on('click',function() {
                self.props.goBack();
            });
        });
    }

    validateData() {
        const enteredData = this.state.fee;
        const title = enteredData.fee_title;
        const amount = enteredData.fee_amount.toString().replace(',', '').replace('.', '');
        const percentage = enteredData.fee_percentage;

        if (title.length == 0) {
            modal.showInfo("Enter a fee name", "warning", "top", "center");
            return false;
        }
        if (parseInt(percentage) == 0 && (amount === undefined || amount <= 0)) {
            modal.showInfo("Enter the fixed amount for this fee!", "danger", "top", "center");
            return false;
        } else if (isNaN(amount)) {
            modal.showInfo("Please enter a valid fixed amount for this fee!", "warning", "top", "center");
            return false;
        }
        if (parseInt(percentage) == 0 && (amount === undefined || amount == 0)) {
            modal.showInfo("Please enter a percentage for this fee!", "warning", "top", "center");
            return false;
        }

        return true;
    }

    render(){
        const newFee = this.props.newFee;
        const enteredData = this.state.fee;
        const title = enteredData.fee_title;
        const description = enteredData.fee_description;
        const amount = enteredData.fee_amount;
        const percentage = enteredData.fee_percentage;
        const isGlobal = enteredData.is_global;
        const is_late_rent = enteredData.is_late_rent;

        var buttonText = 'Update Fee';
        var resetText = '';
        if(newFee) {
            buttonText = 'Add Fee';
        } else {
            resetText = 'Reset'
        }

        return (
        <div>
            <div class="card">
                <div class="header">
                    <h4 class="title">{buttonText}</h4>
                    <p class="category"></p>
                </div>
                <div class="content">
                    <form>
                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label>Name</label>
                                    <input type="text" class="form-control tenant-info" name="name" placeholder="Name" id="name" value={title} onChange={this.handleNameChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-md-offset-1">
                                <div class="form-group">
                                    <label>Description</label>
                                    <input type="text" class="form-control tenant-info" name="description" placeholder="Maintenance coverage" id="description" value={description} onChange={this.handleDescriptionChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label>Is Global <small>- this fee will be added to any rent payment or maintenance invoice.</small></label>
                                    <select class="form-control" value={isGlobal} onChange={this.handleIsGlobalChange.bind(this)}>
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-5 col-md-offset-1">
                                <div class="form-group">
                                    <label for="late_rent_fee">Is Late Rent <small>- this fee will be added to any late rent payment.</small></label>
                                    <br/>
                                    <p class="email-checkbox-text"><input type="checkbox" class="email-checkbox" defaultChecked={is_late_rent} checked={is_late_rent} onChange={this.handleIsLateRent.bind(this)} data-toggle="toggle"/></p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="header" style={{marginLeft: "-15px"}}>
                                    <h4 class="title">Fixed amount ($)</h4>
                                    <p class="category">Enter a fixed amount to be added based on the fee association.</p>
                                </div>
                                <div class="row">
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <label for="address">Amount ($)</label>
                                            <input type="text" class="form-control" value={amount} onChange={this.handleFeeAmountChange.bind(this)} placeholder="$10" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="header" style={{marginLeft: "-15px"}}>
                                    <h4 class="title">Percentage based (%)</h4>
                                    <p class="category">Enter a percentage to be calculated and added based on the fee association.</p>
                                </div>
                                <div class="row">
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <label for="address">Percentage (%)</label>
                                            <input type="text" class="form-control" value={percentage} onChange={this.handleFeePercentageChange.bind(this)} placeholder="5%" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="content">
                                { newFee === false ? (
                                    <div>
                                    <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-left" autoComplete="off" onClick={this.props.goBack}>
                                    Back
                                    </button>
                                    <button style={window.innerWidth < 768 ? {marginRight: 0} : {}} type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.updateFee.bind(this)}>
                                    {buttonText}
                                    </button>
                                    <button style={window.innerWidth < 768 ? {marginRight: 0, marginTop: 10} : {}} type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill pull-right" autoComplete="off" onClick={this.deleteFee.bind(this)}>
                                    Delete Fee
                                    </button>
                                    </div>
                                ) : (
                                    <div>
                                    <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-left" autoComplete="off" onClick={this.props.goBack}>
                                    Back
                                    </button>
                                    <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.saveFee.bind(this)}>
                                    {buttonText}
                                    </button>
                                    </div>
                                )}
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Fee/FeeEdit.jsx